import DateConverter from '../converter/DateConverter.js';
import TimeConverter from '../converter/TimeConverter.js';

function PanelDisplayStockinfo(props) {
   return (
    <div className="step">
        <span>預購記錄</span>
        <br></br>
        <br></br>
        <span>訂單編號：{props.data.Invoice_no}</span>
        <hr></hr>
        <div>
            <ShowInvoiceItems data={props.stock} curr={props.data.Item_Currency} />
        </div>
        <hr></hr>
        <div>
            {/* <span className="stockname">小計</span>
            <span className="stockinfo">{props.data.Item_Currency} {props.data.Item_Subtotal}</span> */}
            <span className="stockname">總計</span>
            <span className="stockinfo">{props.data.Item_Currency} {props.data.Item_Total}</span>
        </div>
        <p className='screen-cap-reminder'>溫馨提示：預購記錄可自行截圖保存。</p>
        <p>
            如您於
            <DateConverter data={props.data.Created_Date}></DateConverter>
            {/* <TimeConverter data={props.data.Created_Date}></TimeConverter> */}
            後尚未收到短訊，請致電顧客服務熱線查詢。
        </p>
    </div>
   );
 }

 function ShowInvoiceItems(props) {
    const groupedData = props.data.reduce((groups, item) => {
            const group = item.Pickup_Group;
            if (!groups[group]) {
                groups[group] = [];
            }
            groups[group].push(item);
            return groups;
        }, {});
    if (Object.keys(groupedData).length == 1){
        return(
            <>
            {
                props.data.map((item) => 
                <>
                    <span className="stockname">{item.Stock_Name} {item.Stock_Tag}</span>
                    <span className="stockinfo">{item.Actual_Currency} {item.Actual_Subtotal}</span>
                    <span className="stockqty">數量: {item.Qty}</span>
                    <p></p>
                </>
                )
            }
        </>
        );
    } else {
        return (
            <>
            {Object.keys(groupedData).map((group, index) => {
                const groupSubtotal = groupedData[group].reduce((subtotal, item) => {
                    return subtotal + parseFloat(item.Actual_Subtotal);
                }, 0);
                return (
                    <div key={group}>
                        <h5>{group}</h5>
                        {
                        groupedData[group].map((item, idx) => (
                            <div key={idx}>
                                <span className="stockqty">{item.Stock_Name} {item.Stock_Tag}</span>
                                <span className="stockname">數量: {item.Qty}</span>
                                <span className="stockinfo">{item.Actual_Currency} {item.Actual_Subtotal}</span>
                                <p></p>
                            </div>
                        ))}
                        <div>
                            <br/>
                            <span className="stockname">小計</span>
                            <span className="stockinfo">{props.curr} {groupSubtotal}</span>
                        </div>
                        {index < Object.keys(groupedData).length - 1 && <hr />}
                    </div>
                );
            })}
        </>
        );
    }
}
 
export default PanelDisplayStockinfo;